import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Chip, Icon, Text } from '@a-type/ui';
import { withGame } from '@long-game/game-client';
export const PlayerStatusChip = withGame(function PlayerStatusChip({ gameSuite, playerId }) {
    const status = gameSuite.playerStatuses[playerId] ?? null;
    return status.online ? (_jsxs(Chip, { emphasis: "primary", className: "@mode-primary", children: [_jsx(Icon, { name: "globe", size: 16 }), _jsx("span", { children: "Online" })] })) : (_jsxs(Chip, { emphasis: "primary", className: "@mode-neutral", children: [_jsx(Icon, { name: "x", size: 16 }), _jsx(Text, { dim: true, children: "Offline" })] }));
});
//# sourceMappingURL=PlayerStatusChip.js.map